import { connect } from 'react-redux'
import { getFormValues, reset } from 'redux-form'
import RecurringReservations from '../components/recurring-reservations'

const getRecurringFormValues = getFormValues("recurring-reservations")

const mapStateToProps = state => ({
  ...state.currentReservation.recurring,
  currentValues: getRecurringFormValues(state),
})

const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch({type: 'GAME_MODAL.SET_LOADING', payload: { isLoading: true }})
    dispatch({type: 'RECURRING_RESERVATIONS.SUBMIT', payload: data})
  },
  initRecurring: id => dispatch({type: 'RECURRING_RESERVATIONS.INIT', payload: id}),
  onRevert: () => {
    dispatch({type: 'RECURRING_RESERVATIONS.RESET_ERRORS'})
    dispatch(reset('recurring-reservations'))
  }
})


export default connect(mapStateToProps, mapDispatchToProps)(RecurringReservations)
